import { z } from 'zod'
import {
  AncillariesLocation,
  CarHireLocation,
  CarHireLocationSchema,
} from '@reward-platform/ancillaries-locations'

export const CarHireSearchFormSchema = z.object({
  dob: z.date(),
  pickUpSearchString: z.string(),
  pickUpDate: z.date(),
  pickUpTime: z.string(),
  dropOffSearchString: z.string(),
  dropOffDate: z.date(),
  dropOffTime: z.string(),
  differentDropOff: z.boolean(),
  isUnderAgeLimit: z.boolean(),
  pickUpLocation: CarHireLocationSchema,
  dropOffLocation: CarHireLocationSchema.optional(),
  membershipCode: z.string().optional(),
  isAvisPreferred: z.boolean(),
})

export type CarHireSearchForm = z.infer<typeof CarHireSearchFormSchema>

export type CarHireLocationOption = {
  isLoading: boolean
  locations?: AncillariesLocation[] | CarHireLocation[]
  searchString: string
  setSearchString?: React.Dispatch<React.SetStateAction<string | null>>
  noResultsFound: boolean
  clearLocation: () => void
  onInputFocus: (e: { target: { select: () => void } }, openMenu: () => void) => void
  handleAutocompleteChange: (value?: string) => void
  handleSuggestionClick: (key: string) => void
  swapLocations: (newName: string, newLocation: CarHireLocation) => void
}
